export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10451.3e3f4043.jpg";